import Ajax from '@utils/ajax';

export default {
  index(options = {}) {
    return Ajax.get({
      url: `/users/fbq_events`,
      ...options,
    });
  },

  markAsProcesed(ids, options = {}) {
    return Ajax.post({
      url: `/users/mark_fbq_events_processed`,
      data: { ids },
      ...options,
    });
  },
};
